<template>

    <div class="layui-row">
        
        <div class="article_main_header">
            
            <div class="article_header__bg" :style="{backgroundImage:`url(${articleDetail.imagUrl})`}"></div>

            <div class="article_header__main">
                <div class="article_bbt-container">
                    <!-- <div class="article_bbt-crumbs article_bbt-crumbs__light">
                        <div>
                            <span class="article_bbt-crumbs__name">
                                <router-link to="/"></router-link>
                                <a href="/" class="article_router-link-active">
                                    <i class="layui-icon layui-icon-home" style="font-size:12px;"></i>
                                    首页
                                </a>
                            </span>
                            <span class="article_bbt-crumbs__arrow">
                                <i class="layui-icon layui-icon-right" style="font-size:12px;"></i>
                            </span>
                        </div>
                        <div>
                            <span class="article_bbt-crumbs__name">
                                <a href="/news" class="">
                                资讯
                                </a>
                            </span>
                            <span class="article_bbt-crumbs__arrow">
                                <i class="layui-icon layui-icon-right" style="font-size:12px;"></i>
                            </span>
                        </div>
                    
                        <div>
                            <span class="article_bbt-crumbs__name">
                                <a href="javascript:;">
                                比特币
                                </a>
                            </span>
                            <span class="article_bbt-crumbs__arrow">
                                <i class="layui-icon layui-icon-right" style="font-size:12px;"></i>
                            </span>
                        </div>

                        <div>
                            <span class="article_bbt-crumbs__name">比特币价格研究 —— 价格形成</span>
                        </div>
                    </div> -->
                            
                    <h1>{{articleDetail.title}}</h1>
                    
                    <div class="article_header__info">
                        <span class="article_header__info-item">
                            <a href="javascript:;" class="">
                                {{articleDetail.author}}
                            </a>
                            <span>{{ $filters.formatDate(articleDetail.createTime) }}</span>
                            <!-- <span> 发布在 </span>
                            <span>
                                <span v-for="item in articleDetail.tags.split(',')" v-bind:key="item">
                                    <a href="javascript:;" class="link-light-minor">{{item}}</a>
                                </span>
                            </span> -->
                        </span>
                        <span class="article_header__info-item">
                            <i class="el-icon-view"></i> {{articleDetail.viewCount == null? 0 : articleDetail.viewCount}}
                        </span>
                    </div>
                </div>
            </div>

        </div>

        <!-- 主体内容 -->
        <div class="main__body main__body--normal">
            <div class="article_bbt-container">
                <div class="bbt-row" style="margin-left:-12px;margin-right:-12px;">
                    
                    <div class="bbt-col-xs-16" style="padding-left:12px;padding-right:12px;">
                        <!-- 文章内容 -->
                        <div class="bbt-html" v-html="articleDetail.content"></div>
                        <!-- 免责声明 -->
                        <div class="copyright-module">
                            <div class="copyright-module__header bbt-clearfix">
                                <!-- <span>发文时比特币价格：<span class="color-primary">¥72646.62</span></span> -->
                                <!-- <span class="header__right">特别声明 <i class="bbt-icon bbt-icon-up rotate"></i></span> -->
                                <span>特别声明 <i class="bbt-icon bbt-icon-up rotate"></i></span>
                            </div>

                            <div class="copyright-module__body" style="display:;">
                                <p>来源：贵州省新一代信息技术科普服务平台</p>
                                <!-- <p>免责声明：本文不代表马尔比特比特立场，且不构成投资建议，请谨慎对待。</p> -->
                                <p>
                                    版权声明：
                                    <!-- <a href="https://creativecommons.org/licenses/by-nc-sa/3.0/cn/" rel="nofollow noopener noreferrer" target="_blank">
                                        <img src="https://cdn.8btc.com/wp-content/themes/8btctest1/custom/images/by.png" alt="by">
                                        <img src="https://cdn.8btc.com/wp-content/themes/8btctest1/custom/images/nc.png" alt="nc">
                                        <img src="https://cdn.8btc.com/wp-content/themes/8btctest1/custom/images/sa.png" alt="sa">
                                    </a> -->
                                    <span data-v-923825fa="">原创文章，未经授权禁止转载。</span>
                                </p>
                                <!-- <p data-v-923825fa="">
                                    版权认证：
                                    <a href="https://www.baoquan.com/attestations/F8F31310AD5E4048A70BE750198C5FFC" target="_blank" rel="nofollow noopener noreferrer">
                                        <img src="https://www.8btc.com/public/common/baoquan.png" alt="">
                                    </a>
                                    <span data-v-923825fa="">本文已在保全网存证确权，侵权必究！</span>
                                </p> -->
                            </div>
                        </div>
                        <!-- 文章标签 -->
                        <div class="tag-module" v-if="articleDetail.tags">
                            文章标签：
                            <span v-for="item in articleDetail.tags.split(',')" v-bind:key="item"  class="bbt-tag bbt-tag--flame">
                                {{item}}
                            </span>
                        </div>
                        <!-- 分享链接 -->
                        <div class="share-module">
                            <div class="share-module__fix">
                                <div class="">
                                    <div class="bbt-clearfix" style="padding-left:0;">
                                        <div class="share-module__left">
                                            <!-- <button class="bbt-btn bbt-btn--primary share-module__item" @click="supportSave">
                                                <i class="layui-icon layui-icon-praise"></i> 点赞 0
                                            </button> -->
                                            <el-button v-if="supportFlag == 1" size="small" @click="supportSave" class="share-module__item"><i class="layui-icon layui-icon-praise"></i> 点赞 0</el-button>
                                            <el-button v-else type="primary" size="small" @click="supportSave" class="share-module__item"><i class="layui-icon layui-icon-praise"></i> 点赞 0</el-button>
                                            <a href="javascript:;" class="link-dark-minor share-module__item">
                                                <i class="layui-icon layui-icon-dialogue"></i> {{commentList.length}} 条评论
                                            </a>
                                            <!-- <div class="link-dark-minor share-module__item">
                                                <div class="share-box visibbottom">
                                                    <span><i class="layui-icon layui-icon-share" style="font-size:16px;"></i>分享</span>
                                                </div>
                                            </div> -->
                                        </div>
                                        <div class="share-module__right" v-if="articleDetail.nextArticleId != null">
                                            下一篇：
                                            <router-link :to="{path:'/articleDetail/' + articleDetail.nextArticleId}" class="link-dark-major">
                                                {{articleDetail.nextArticleTitle}}
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 推荐资讯 -->
                        <div class="bbt-module related-module">
                            <div class="bbt-module__header"><span>推荐资讯</span></div>
                            <div class="bbt-row" style="margin-left:-12px;margin-right:-12px;">
                                <div class="bbt-col-xs-8" style="padding-left:12px;padding-right:12px;" v-for="item in recommandInfo" :key="item.id">
                                    <div class="related-module__item">
                                        <div class="item__thumb">
                                            <router-link :to="{path:'/articleDetail/' + item.id}" class="link-dark-major font-bold bbt-block">
                                                <el-image :src="item.imagUrl" :fit="contain" lazy style="width:227px;height:144px;">
                                                    <div slot="error" class="image-slot">
                                                        <i class="el-icon-picture-outline"></i>
                                                    </div>
                                                </el-image>
                                            </router-link>
                                        </div>
                                        <div class="item__title">
                                            <router-link :to="{path:'/articleDetail/' + item.id}" class="link-dark-major font-bold bbt-block">
                                                {{item.title}}
                                            </router-link>
                                        </div>
                                        <div class="item__info bbt-clearfix">
                                            <span><i class="el-icon-view"></i> {{item.viewCount}}</span>
                                            <!-- <span><i class="layui-icon layui-icon-reply-fill"></i> 11</span> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 评论/用户登录 -->
                        <div>
                            <div id="comment-module" class="comment-module">
                                <!-- <div class="comment-module__header">评论<span v-if="commentList.length > 0">（{{commentList.length}}）</span></div>
                                <div class="comment-module__alert" v-if="user.username == null">
                                    <a href="/pages/userAction.html?t=l" target="_blank" class="link-dark-major">
                                        登录
                                    </a>
                                    账号发表你的看法，还没有账号？立即免费
                                    <a href="/pages/userAction.html?t=r" class="link-dark-major">
                                        注册
                                    </a>
                                </div> -->

                                <!-- <div v-else>
                                    <el-row>
                                        <el-input
                                            type="textarea"
                                            placeholder="合理发言，塑造健康环境"
                                            v-model="commentText"
                                            maxlength="150"
                                            show-word-limit
                                            >
                                        </el-input>
                                    </el-row>
                                    <el-row>
                                        <el-col :span="3" :offset="21">
                                            <el-button type="primary" plain style="width:97px;" @click="saveCommoents">发表</el-button>
                                        </el-col>
                                    </el-row>
                                </div> -->

                                <!-- 回复框 -->
                                <!-- <ul class="comment-list" v-if="commentList.length > 0">
                                    <li class="comment" v-for="(item, index) in commentList" :key="item.topic.id">
                                        <div class="comment__thumb">
                                            <img :src="item.topic.thumbImg == 'default.jpg'? `${publicPath}` + 'default/avatar.webp' : item.topic.thumbImg" class="bbt-avatar bbt-avatar--sm">
                                        </div>
                                        <div class="comment__body">
                                            <div class="comment__title">
                                                {{item.topic.nickname}}
                                                <span class="comment__time">
                                                {{item.topic.createTime | timeInteval}}
                                                </span>
                                            </div>
                                            <div class="comment__content">
                                                {{item.topic.content}}
                                            </div>
                                            <div class="comment__action">
                                                <a href="javascript:;" class="comment__action-item link-dark-minor comment_praise" @click="commentPraise">
                                                    <i class="layui-icon layui-icon-praise"></i> {{item.topic.likeNum}} 赞
                                                </a>
                                                <a href="javascript:;" class="comment__action-item link-dark-minor comment_reply" @click="commentReply">
                                                    <i class="layui-icon layui-icon-reply-fill"></i> {{item.topic.replyNum}} 回复
                                                </a>
                                                <a href="javascript:;" class="comment__action-item link-dark-minor comment_tread" @click="commentTread">
                                                    <i class="layui-icon layui-icon-tread"></i> {{item.topic.isReply}} 踩
                                                </a>
                                            </div>
                                            
                                            <div class="reply-form" style="display:none;">
                                                <div class="reply-form__comment-wrap">
                                                    <input id="reply_comment_0" :placeholder="item.topic.content" v-model="replyText" class="reply-form__comment">
                                                </div>
                                                <div class="reply-form__action">
                                                    <button class="bbt-btn bbt-btn-link--default" @click="cancelReply">
                                                        取消
                                                    </button>
                                                    <button class="bbt-btn bbt-btn--primary" @click="confirmReply"
                                                        :data-index="index"
                                                        :data-touid="item.topic.fromUid"
                                                        :data-tonickname="item.topic.nickname" 
                                                        :data-replytype="item.topic.topicType" 
                                                        :data-articleid="item.topic.articleId" 
                                                        :data-commentid="item.topic.id">
                                                        回复
                                                    </button>
                                                </div>
                                            </div>

                                            <ul class="comment-list" v-if="item.replays.length > 0">
                                                <li class="comment" v-for="repItem in item.replays" :key="repItem.replay.id">
                                                    <div class="comment__thumb">
                                                        <img :src="repItem.replay.fromThumbImg" class="bbt-avatar bbt-avatar--sm">
                                                    </div>
                                                    <div class="comment__body">
                                                        <div class="comment__title">
                                                            {{repItem.replay.fromNickname}}
                                                            <span class="comment__time">
                                                            {{repItem.replay.createTime | timeInteval}}
                                                            </span>
                                                        </div>
                                                        <div class="comment__content">
                                                            {{repItem.replay.content}}
                                                        </div>
                                                        <div class="comment__action">
                                                            <a href="javascript:;" class="comment__action-item link-dark-minor comment_praise" @click="commentPraise">
                                                                <i class="layui-icon layui-icon-praise"></i> {{repItem.replay.likeNum}} 赞
                                                            </a>
                                                            <a href="javascript:;" class="comment__action-item link-dark-minor comment_reply" @click="commentReply">
                                                                <i class="layui-icon layui-icon-reply-fill"></i> {{repItem.replay.replyNum}} 回复
                                                            </a>
                                                            <a href="javascript:;" class="comment__action-item link-dark-minor comment_tread" @click="commentTread">
                                                                <i class="layui-icon layui-icon-tread"></i> {{repItem.replay.isReply}} 踩
                                                            </a>
                                                        </div>
                                                        
                                                        <div class="reply-form" style="display:none;">
                                                            <div class="reply-form__comment-wrap">
                                                                <input id="reply_comment_0" :placeholder="repItem.replay.content" v-model="replyText" class="reply-form__comment">
                                                            </div>
                                                            <div class="reply-form__action">
                                                                <button class="bbt-btn bbt-btn-link--default" @click="cancelReply">
                                                                    取消
                                                                </button>
                                                                <button class="bbt-btn bbt-btn--primary" @click="confirmReply"
                                                                    :data-touid="repItem.replay.fromUid" 
                                                                    :data-tonickname="repItem.replay.toNickname" 
                                                                    :data-replytype="repItem.replay.replyType" 
                                                                    :data-articleid="item.topic.articleId" 
                                                                    :data-commentid="repItem.replay.id">
                                                                    回复
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            </ul>

                                        </div>
                                    </li>
                                </ul> -->
                            </div>
                        </div>

                    </div>

                    <!-- 文章右侧内容 -->
                    <div class="bbt-col-xs-7 bbt-col-xs-offset-1" style="padding-left:12px;padding-right:12px;">
                        <aside class="article_main__sidebar">
                            <div class="author-module">
                                <div class="author-module__header">
                                    <div class="author-module__avatar">
                                        <router-link :to="'/authorDetail/' + articleDetail.authorId">
                                            <img :src="`${publicPath}default/avatar.webp`" class="bbt-avatar bbt-avatar--lg" lazy="loaded" v-if="authorDetail.authorImage == '' || authorDetail.authorImage == null">
                                            <img :src="articleDetail.authorImage" class="bbt-avatar bbt-avatar--lg" lazy="loaded" v-else>
                                        </router-link>
                                    </div>
                                    <div class="author-module__right">
                                        <div class="author-module__title">
                                            <router-link :to="'/authorDetail/' + (articleDetail.authorId == null? articleDetail.userId : articleDetail.authorId)" class="link-dark-major">
                                                {{articleDetail.author == null? articleDetail.userName : articleDetail.author}}
                                            </router-link>
                                            <button v-if="concernFlag == 1" @click="concernSave" class="bbt-btn bbt-btn--primary bbt-btn--sm author-module__follow">
                                                关注
                                            </button>
                                            <el-button v-else @click="concernSave" type="info" size="mini" class="author-module__follow" plain>取消关注</el-button>
                                        </div>
                                        <div class="author-module__info bbt-clearfix">
                                            <span class="author-module__info-item" v-if="articleDetail.viewCount">文章数 <span>{{articleDetail.viewCount}}</span></span>
                                            <span class="author-module__info-item" v-if="articleDetail.fansCount">获赞数 <span>{{articleDetail.fansCount}}</span></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="author-module__content">
                                    {{articleDetail.descriptions}}
                                </div>
                                <ul class="bbt-list">
                                    <li v-for="item in authorArticles" :key="item.id">
                                        <router-link :to="{path:'/articleDetail/' + item.id}" class="link-dark-major router-link-exact-active router-link-active">
                                            {{item.title}}
                                        </router-link>
                                    </li>
                                </ul>
                                <div class="author-module__more">
                                    <router-link :to="'/authorDetail/' + (articleDetail.authorId == null? articleDetail.userId + '?p=post' : articleDetail.authorId)" class="bbt-btn bbt-btn--primary bbt-btn-block">
                                    阅读作者更多精彩文章
                                    </router-link>
                                </div>
                            </div>
                            <!-- <div class="bbt-ad bbt-ad__normal" style="margin-bottom:48px;">
                                <a href="https://www.chainnode.com/event/364420" target="_blank" rel="nofollow noopener noreferrer">
                                    <img src="https://appserversrc.8btc.com/propaganda/img/20190828181501_69100.jpg" width="100%" height="auto">
                                    <span class="bbt-ad__tag">赞助</span>
                                </a>
                            </div> -->
                            <div class="bbt-module">
                                <div class="bbt-module__header">
                                    热门标签
                                </div>
                                <div class="bbt-module__body" style="padding-bottom:8px">
                                    <router-link :to="{path:'/search/' + item}" class="bbt-tag bbt-tag--flame" v-for="item in hotTags" v-bind:key="item">
                                        {{item}}
                                    </router-link>
                                </div>
                            </div>
                        </aside>
                    </div>

                </div>
            </div>
        </div>
        
    </div>
    
</template>

<script>
import {
    getArticleInfo,
    getAuthorArticles,
    getArticleComments,
    getRecommonderArticles,
    getHatTags,
    getPostContent,
    getPostComments
} from '@/api/api'
    export default {
        name:'ArticleDetail',
        data(){
            return {
                publicPath: process.env.BASE_URL,
                hotTags:[],
                authorArticles:[],
                recommandInfo:[],
                articleDetail:{},
                authorDetail:{},
                // comments:{},
                user:{},
                commentList:[],
                commentText:'',
                replyText:'',
                supportFlag: 1,
                concernFlag: 1
            }
        },
        props:{
            serveHost: String
        },
        filters:{
            
        },
        methods:{
            initArticleDetail:function(newArticleId) {
                var _vm = this;
                // console.log(this.$route);
                var articleId = newArticleId == null?this.$route.params.article_id : newArticleId;
                var t = this.$route.query.t;
                if(t === 'p') {
                    // 帖子详情
                    getPostContent({articleId: articleId}).then((res)=>{
                        let r = res.data;
                        if(r.code === "1000006") {
                            _vm.$alert(r.msg, '提示', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    location.href = "/";
                                }
                            });
                        }
                        if(r.code != "2000000") {
                            console.error('get getArticleInfo error.');
                            return;
                        } 
                        this.articleDetail = r.data;
                    });

                    // 获取帖子评论
                    getPostComments({articleId: articleId}).then((res)=>{
                        let r = res.data;
                        if(r.code != "2000000") {
                            console.error('get comments error.');
                            return;
                        } 
                        this.commentList = r.data;
                    });
                } else {
                    // 文章详情
                    getArticleInfo({articleId: articleId}).then((res) =>{
                        let r = res.data;
                        if(r.code != "2000000") {
                            console.error('get getArticleInfo error.');
                            return;
                        } 
                        this.articleDetail = r.data;
                        // 作者其他文章
                        getAuthorArticles({authorId: r.data.authorId}).then((res)=>{
                            let r = res.data;
                            if(r.code != "2000000") {
                                console.error('get getAuthorArticles error.');
                                return;
                            } 
                            this.authorArticles = r.data.articles;
                            this.authorDetail = r.data.author;
                        });
                    });
                    // 获取文章评论
                    getArticleComments({articleId: articleId}).then((res)=>{
                        let r = res.data;
                        if(r.code != "2000000") {
                            console.error('get comments error.');
                            return;
                        } 
                        this.commentList = r.data;
                    });
                }
                // 推荐资讯
                getRecommonderArticles({articleId: articleId}).then((res)=>{
                    let r = res.data;
                    if(r.code != "2000000") {
                        console.error('get recommonderArticles error.');
                        return;
                    } 
                    this.recommandInfo = r.data;
                });
                // 热门标签
                getHatTags().then((res)=>{
                    let r = res.data;
                    if(r.code != "2000000") {
                        console.error('get getHatTags error.');
                        return;
                    } 
                    this.hotTags = r.data;
                });
            },
            supportSave:function() {
                var _vm = this;
                // console.log(_vm.articleDetail)
                // 点赞
                $.ajax({
                    type:'POST',
                    url:_vm.serveHost + "/api/v1/user/support/save",
                    data:{
                        articleId:_vm.articleDetail.id,
                        userId:_vm.user.userid,
                        authorId:_vm.articleDetail.authorId,
                        support: _vm.supportFlag
                    },
                    headers:{
                        Authorization:localStorage.getItem('token')
                    },
                    success:function(r) {
                        // console.log(r);
                        if(r.code != "2000000") {
                            _vm.$alert('点赞失败，请先登录', '提示', {
                                type:'warning',
                                closeOnClickModal:true,
                                closeOnPressEscape:true,
                                confirmButtonText: '确定',
                                callback: action => {
                                    
                                }
                            });
                            console.error('get support error.');
                            return;
                        } else {
                            if(_vm.supportFlag == 1) {
                                _vm.$message({
                                    message:'点赞成功',
                                    type:'success'
                                });
                                _vm.supportFlag = 0;
                            } else {
                                _vm.$message('已取消');
                                _vm.supportFlag = 1;
                            }
                            
                        }
                    }
                });
            },
            concernSave:function() {
                var _vm = this;
                // 关注
                $.ajax({
                    type:'POST',
                    url:_vm.serveHost + "/api/v1/user/concern/save",
                    data:{
                        userId:_vm.user.userid,
                        authorId:_vm.articleDetail.authorId,
                        concern: _vm.concernFlag
                    },
                    headers:{
                        Authorization:localStorage.getItem('token')
                    },
                    success:function(r) {
                        // console.log(r);
                        if(r.code != "2000000") {
                            _vm.$alert('关注失败，请先登录', '提示', {
                                type:'warning',
                                closeOnClickModal:true,
                                closeOnPressEscape:true,
                                confirmButtonText: '确定',
                                callback: action => {
                                    
                                }
                            });
                            console.error('get support error.');
                            return;
                        } else {
                            if(_vm.concernFlag == 1) {
                                _vm.$message({
                                    message:'关注成功',
                                    type:'success'
                                });
                                _vm.concernFlag = 0;
                            } else {
                                _vm.$message('已取关');
                                _vm.concernFlag = 1;
                            }
                        }
                    }
                });
            },
            // 评论
            saveCommoents:function () {
                var _vm = this;
                let t = this.$route.query.t;
                let url = '';
                let d = {};
                if(_vm.commentText == '') {
                    _vm.$message({
                        message:'评论不能为空',
                        type:'warning'
                    });
                    return;
                }
                if(t === 'p') {
                    // 帖子评论
                    url = _vm.serveHost + "/api/v1/post/comments/commit";
                    d = {
                        postId:_vm.$route.params.article_id,
                        fromId:_vm.user.userid,
                        content:_vm.commentText,
                        nickname:_vm.user.nickName,
                        thumbImg:_vm.user.avatar
                    };
                } else {
                    // 文章评论
                    url = _vm.serveHost + "/api/v1/comments/commit";
                    d = {
                        articleId:_vm.articleDetail.id,
                        fromId:_vm.user.userid,
                        content:_vm.commentText,
                        nickname:_vm.user.nickName,
                        thumbImg:_vm.user.avatar
                    };
                    
                }
                $.ajax({
                    type:'POST',
                    url: url,
                    data: d,
                    headers:{
                        Authorization:localStorage.getItem('token')
                    },
                    success:function(r) {
                        // console.log(r);
                        if(r.code != "2000000") {
                            if(_vm.user.commentAuth != 0) {
                                _vm.$message({
                                    message:'无评论权，请先申请',
                                    type:'error'
                                });
                            } else {
                                _vm.$message({
                                    message:'评论失败，尝试重新登录',
                                    type:'warning'
                                });
                            }
                        } else {
                            _vm.$message({
                                message:'发表成功',
                                type:'success'
                            });
                            _vm.commentText = '';
                            _vm.commentList.push(r.data);
                        }
                    }
                });
            },
            commentPraise:function() {

            },
            commentReply:function(event) {
                // $(event.target).parents('.reply-form').fadeOut();
                let dis = $(event.target).parent().siblings('.reply-form').css('display');
                // console.log(dis);
                // console.log(event.target);
                if(dis === 'none') {
                    $(event.target).parent().siblings('.reply-form').fadeIn(.3).css('display', 'block');
                } else {
                    $(event.target).parent().siblings('.reply-form').fadeOut(.3).css('display', 'none');
                }
            },
            commentTread:function() {
                
            },
            cancelReply(event) {
                $(event.target).parents('.reply-form').fadeOut(.3);
                this.replyText = '';
            },
            // 回复
            confirmReply(event) {
                let t = this.$route.query.t;
                var _vm = this;
                var index = event.target.dataset.index;
                var toUid = event.target.dataset.touid;
                var toNickname = event.target.dataset.tonickname;
                var commentId = event.target.dataset.commentid;
                var articleid = event.target.dataset.articleid;
                var replyType = event.target.dataset.replytype;
                var replyId = replyType === '1'? commentId : articleid;
                let url = "";
                let d = {};
                $(event.target).parents('.reply-form').fadeOut(.3);
                if(t === 'p') {
                    // 帖子回复
                    url = _vm.serveHost + "/api/v1/post/comments/commit";
                    d = {
                        postId:_vm.$route.params.article_id,
                        fromId:_vm.user.userid,
                        content:_vm.commentText,
                        nickname:_vm.user.nickName,
                        thumbImg:_vm.user.avatar
                    };
                } else {
                    // 文章回复
                    url = _vm.serveHost + "/api/v1/commentreply/commit";
                    d = {
                        commentId:commentId,
                        replyType:replyType,
                        replyId:replyId,
                        content:_vm.replyText,
                        toUid:toUid,
                        fromUid:_vm.user.userid,
                        fromThumbImg:_vm.user.avatar,
                        fromNickname:_vm.user.nickName,
                        toNickname:toNickname
                    };
                }

                $.ajax({
                    type:'POST',
                    url: url,
                    data: d,
                    headers:{
                        Authorization:localStorage.getItem('token')
                    },
                    success:function(r) {
                        // console.log(r);
                        if(r.code != "2000000") {
                            if(_vm.user.commentAuth != 0) {
                                _vm.$message({
                                    message:'无回复权，请先申请',
                                    type:'error'
                                });
                            } else {
                                _vm.$message({
                                    message:r.msg,
                                    type:'warning'
                                });
                            }
                            _vm.replyText = '';
                        } else {
                            _vm.$message({
                                message:'发表成功',
                                type:'success'
                            })
                            _vm.commentList[index].replays.push(r.data.replays[0]);
                        }
                    }
                });
            }
        },
        computed:{
        },
        watch:{
            '$route' (to, from){
                this.initArticleDetail(this.$route.params.article_id)
            }
        },
        created:function(){
            this.initArticleDetail();
            this.user = localStorage.getItem('user') == null? {} : JSON.parse(localStorage.getItem('user'));
        },
        mounted:function() {
        },
        updated(){
            
        }
    }
</script>

<style scoped>

    *, :after, :before {
        box-sizing: border-box;
    }
    /* 侧边作者信息栏 */
    .bbt-tag {
        margin-bottom: 16px;
    }
    .bbt-ad__tag {
        position: absolute;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,.56);
        border-radius: 4px 0 0 0;
        padding: 0 6px;
        color: #fff;
        font-size: 12px;
        line-height: 20px;
    }
    aside {
        display: block;
    }
    .article_main__sidebar {
        position: relative;
        z-index: 3;
        margin-top: -72px;
    }
    .author-module {
        padding: 24px;
        border-radius: 6px;
        margin-bottom: 24px;
        background: #fff;
        background: #f8f8f8;
        transition: all .3s ease;
    }
    .author-module__info-item+.author-module__info-item {
        margin-left: 16px;
    }
    .author-module__info-item>span {
        font-size: 16px;
        line-height: 24px;
        color: rgba(0,0,0,.88);
        font-weight: 700;
    }
    .bbt-btn.bbt-btn--sm {
        font-size: 12px;
        padding: 7px 10px;
        border-radius: 4px;
    }
    .author-module__follow {
        float: right;
        opacity: 1;
    }
    li {
        display: list-item;
        text-align: -webkit-match-parent;
    }
    .bbt-list>li:before {
        content: "";
        position: absolute;
        left: 0;
        top: 9px;
        width: 4px;
        height: 4px;
        background: rgba(0,0,0,.16);
        border-radius: 1px;
    }
    ul {
        display: block;
        list-style-type: disc;
        margin-block-start: 1em;
        margin-block-end: 1em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
        padding-inline-start: 40px;
    }
    .bbt-tag.bbt-tag--flame {
        color: #f46300;
        background: rgba(244,99,0,.12);
    }
    .bbt-tag {
        font-size: 12px;
        line-height: 20px;
        border-radius: 100px;
        padding: 3px 12px;
        margin-right: 8px;
        display: inline-block;
        transition: all .3s ease;
        font-weight: 500;
    }
    .bbt-module__header {
        font-size: 20px;
        line-height: 28px;
        color: rgba(0,0,0,.88);
        font-weight: 700;
        margin-bottom: 16px;
        position: relative;
        padding-left: 12px;
    }
    .bbt-ad img {
        min-height: 100px;
        display: block;
        transition: all .3s ease;
    }
    
    .bbt-btn.bbt-btn--primary {
        color: #fff;
        background: #409EFF;
        border-color: #409EFF;
        transition: all .3s ease;
    }
    .bbt-btn.bbt-btn-block {
        display: block;
        width: 100%;
    }
    .author-module__more {
        margin: 16px auto 0;
    }
    .link-dark-major {
        color: rgba(0,0,0,.88);
        transition: all .3s ease;
    }

    .link-dark-major:hover {
        color:#e00;
    }

    .bbt-list>li a {
        display: inline-block;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .bbt-list>li {
        position: relative;
        font-size: 14px;
        line-height: 22px;
        font-weight: 700;
        list-style: none;
        padding-left: 16px;
        height: 22px;
    }
    .bbt-list {
        margin: 0 auto;
        padding-left: 0;
    }
    .author-module__info {
        color: rgba(0,0,0,.56);
        font-size: 12px;
        line-height: 20px;
    }
    .author-module__content {
        color: rgba(0,0,0,.56);
        font-size: 14px;
        line-height: 22px;
        padding-bottom: 16px;
        margin-bottom: 16px;
        border-bottom: 1px dashed rgba(0,0,0,.08);
        word-break: break-all;
    }
    .author-module__title {
        font-size: 18px;
        line-height: 26px;
        color: rgba(0,0,0,.88);
        font-weight: 700;
        margin-bottom: 8px;
    }
    .author-module__right {
        display: table-cell;
        vertical-align: top;
        width: 10000px;
    }
    .author-module__avatar {
        display: table-cell;
        vertical-align: top;
        padding-right: 16px;
        position: relative;
    }
    .author-module__header {
        margin-bottom: 16px;
    }
    .bbt-ad {
        position: relative;
        margin-bottom: 24px;
        border-radius: 4px;
        overflow: hidden;
    }
    .bbt-module {
        padding-bottom: 8px;
    }
    .bbt-module {
        margin-bottom: 48px;
        background: #f8f8f8;
        padding: 24px;
        border-radius: 4px;
        transition: all .3s ease;
    }
    .main__sidebar {
        position: relative;
        z-index: 3;
        margin-top: -72px;
    }
    /* 主体样式 */

    .bbt-btn.bbt-btn-link--default {
        color: rgba(0,0,0,.88);
        transition: all .3s ease;
    }
    .bbt-btn {
        display: inline-block;
        text-align: center;
        vertical-align: middle;
        touch-action: manipulation;
        cursor: pointer;
        white-space: nowrap;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        font-size: 14px;
        font-weight: 500;
        padding: 9px 15px;
        line-height: 1;
        border: 1px solid transparent;
        background: none;
        border-radius: 4px;
        outline: none;
    }
    

    input {
        -webkit-writing-mode: horizontal-tb !important;
        text-rendering: auto;
        color: initial;
        letter-spacing: normal;
        word-spacing: normal;
        text-transform: none;
        text-indent: 0px;
        text-shadow: none;
        display: inline-block;
        text-align: start;
        -webkit-appearance: textfield;
        background-color: white;
        -webkit-rtl-ordering: logical;
        cursor: text;
        margin: 0em;
        font: 400 13.3333px Arial;
        padding: 1px 0px;
        border-width: 2px;
        border-style: inset;
        border-color: initial;
        border-image: initial;
    }
    
    .bbt-clearfix:after {
        clear: both;
    }

    .bbt-clearfix:after, .bbt-clearfix:before {
        display: table;
        content: "";
    }

    .related-module .item__info span {
        float: left;
        margin-right: 24px;
    }
    .related-module .item__info {
        position: absolute;
        bottom: 0;
        color: rgba(0,0,0,.56);
        font-size: 14px;
        line-height: 22px;
    }
    .related-module .item__title {
        font-size: 16px;
        line-height: 24px;
        font-weight: 700;
        margin-bottom: 8px;
        height: 48px;
        overflow: hidden;
    }
    .related-module .item__thumb img {
        height: 136px!important;
        border-radius: 4px;
        transition: all .3s ease;
    }
    .related-module .item__info {
        position: absolute;
        bottom: 0;
        color: rgba(0,0,0,.56);
        font-size: 14px;
        line-height: 22px;
    }
    .related-module .item__title {
        font-size: 16px;
        line-height: 24px;
        font-weight: 700;
        margin-bottom: 8px;
        height: 48px;
        overflow: hidden;
    }
    .related-module .item__thumb {
        margin-bottom: 8px;
        border-radius: 4px;
        overflow: hidden;
        position: relative;
    }
    .related-module__item {
        position: relative;
        height: 232px;
    }
    .bbt-col-xs-8 {
        float: left;
        -ms-flex: 0 0 auto;
        flex: 0 0 auto;
        width: 33.33333333%;
    }
    .bbt-module__header {
        font-size: 20px;
        line-height: 28px;
        color: rgba(0,0,0,.88);
        font-weight: 700;
        margin-bottom: 16px;
        position: relative;
        padding-left: 12px;
    }
    .bbt-module__header:before {
        content: "";
        width: 4px;
        height: 20px;
        position: absolute;
        top: 4px;
        left: 0;
        border-radius: 2px;
        background: #e00;
    }
    .related-module{
        margin-bottom: 40px;
    }

    .bbt-module {
        margin-bottom: 48px;
        background: #f8f8f8;
        padding: 24px;
        border-radius: 4px;
        transition: all .3s ease;
    }

    .share-module__right .link-dark-major {
        font-weight: 700;
    }
    .share-module__right {
        float: right;
        width: 40%;
        text-align: right;
        margin-top: 6px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .share-module__item {
        display: inline-block;
        margin-right: 24px;
    }
    .share-module {
        color: rgba(0,0,0,.56);
        vertical-align: middle;
        padding-bottom: 16px;
        margin-bottom: 32px;
        border-bottom: 1px solid rgba(0,0,0,.08);
        font-size: 14px;
        line-height: 22px;
    }

    .link-dark-minor {
        color: rgba(0,0,0,.56);
        transition: all .3s ease;
    }
    .link-dark-minor {
        color: rgba(0,0,0,.56);
        transition: all .3s ease;
    }
    .share-module__item {
        display: inline-block;
        margin-right: 24px;
    }
    
    .share-module__left {
        float: left;
        width: 60%;
    }
    .share-module__fix {
        padding: 8px 0;
    }

    .bbt-tag.bbt-tag--flame {
        color: #f46300;
        background: rgba(244,99,0,.12);
    }
    .bbt-tag {
        font-size: 12px;
        line-height: 20px;
        border-radius: 100px;
        padding: 3px 12px;
        margin-right: 8px;
        display: inline-block;
        transition: all .3s ease;
        font-weight: 500;
    }

    .tag-module {
        padding-top: 8px;
        margin-bottom: 16px;
        font-weight: 700;
    }

    .copyright-module__body img {
        display: inline-block;
        width: 18px;
        vertical-align: middle;
        position: relative;
        top: -1px;
        margin: 0 2px;
    }

    .copyright-module__body p {
        margin: 0;
        line-height: 28px;
        word-break: break-all;
    }

    .copyright-module__body {
        margin-top: 16px;
        font-size: 12px;
        line-height: 20px;
    }

    .copyright-module .header__right {
        position: relative;
        float: right;
        padding-right: 20px;
    }

    .copyright-module__header {
        font-size: 14px;
        line-height: 22px;
    }

    .copyright-module {
        padding: 16px;
        margin-bottom: 16px;
        background: rgba(0,0,0,.02);
        border: 1px solid rgba(0,0,0,.04);
        border-radius: 4px;
        color: rgba(0,0,0,.56);
    }

    .bbt-html img {
        max-width: 100%;
        height: auto;
    }

    .bbt-html blockquote {
        word-break: normal;
        word-wrap: break-word;
        padding: 0;
        margin: 24px auto;
        color: rgba(0,0,0,.88);
        border-left: 4px solid #e00;
        background: #fafafa;
        padding: 16px;
        line-height: 28px;
        font-size: 16px;
    }

    p {
        display: block;
        margin-block-start: 1em;
        margin-block-end: 1em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
    }

    .bbt-html {
        font-size: 16px;
        margin-bottom: 24px;
        color: rgba(0,0,0,.88);
        line-height: 28px;
        word-break: break-all;
    }

    .bbt-col-xs-offset-1 {
        margin-left: 4.16666667%;
    }
    .bbt-col-xs-7 {
        float: left;
        -ms-flex: 0 0 auto;
        flex: 0 0 auto;
        width: 29.16666667%;
    }

    .bbt-col-xs-16 {
        float: left;
        -ms-flex: 0 0 auto;
        flex: 0 0 auto;
        width: 66.66666667%;
    }

    .bbt-row:after {
        clear: both;
    }

    .bbt-row:after, .bbt-row:before {
        content: " ";
        display: table;
    }
    .main__body--normal {
        z-index: 3;
    }

    .main__body {
        position: relative;
    }

    .article_main_header {
        position: relative;
        height: 320px;
        overflow: hidden;
        margin-bottom: 16px;
        z-index: 1;
        width: 100%;
    }

    .article_main_header .article_header__bg {
        position: absolute;
        top: -40px;
        left: -40px;
        right: -40px;
        bottom: -40px;
        background-position: 50%;
        background-size: 100%;
        filter: blur(20px);
        z-index: 1;
    }

    .article_main_header .article_bbt-container {
        position: relative;
        padding-top: 16px;
        padding-bottom: 40px;
        height: 100%;
    }

    .article_main_header .article_header__main {
        position: relative;
        background-image: linear-gradient(-180deg,transparent,#000);
        background-size: cover;
        z-index: 2;
        height: 100%;
    }

    .article_bbt-crumbs>div {
        display: inline;
    }

    @media (min-width: 1200px) {
        .article_bbt-container {
            width: 1200px;
        }
    }

    .article_bbt-container {
        padding-left: 12px;
        padding-right: 12px;
        margin: 0 auto;
    }

    .article_bbt-crumbs__light .article_bbt-crumbs__arrow, .article_bbt-crumbs__light .article_bbt-crumbs__name {
        color: #fff;
    }

    .article_bbt-crumbs__name {
        font-size: 12px;
        line-height: 20px;
        color: rgba(0,0,0,.56);
    }

    .article_bbt-crumbs__arrow {
        margin: 0 4px;
        color: rgba(0,0,0,.56);
    }

    .article_bbt-crumbs__light a {
        color: #fff;
        transition: all .3s ease;
    }
    a {
        text-decoration: none;
    }

    .article_bbt-icon {
        line-height: 1;
        font-size: 14px;
    }

    .article_bbt-icon {
        font-family: bbt-icon!important;
        font-size: 16px;
        font-style: normal;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    .bbt-icon-right:before {
        content: ">";
    }

    .article_main_header h1 {
        position: absolute;
        left: 12px;
        right: 12px;
        bottom: 186px;
        color: #fff;
        font-size: 38px;
        line-height: 46px;
        font-weight: 700;
        margin: 0;
    }

    .article_main_header .article_header__info {
        position: absolute;
        left: 12px;
        right: 12px;
        bottom: 132px;
        font-size: 14px;
        line-height: 22px;
        color: hsla(0,0%,100%,.64);
    }

    .article_main_header .article_header__info-item {
        margin-right: 16px;
    }

    .article_main_header .article_header__info a {
        color: #fff;
        margin-right: 4px;
        transition: all .3s ease;
    }
</style>